import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import Snackbar from '@material-ui/core/Snackbar';
import { Alert } from '@material-ui/lab';
import * as Icon from '../../Imports/Icons';
import Avatar from '@material-ui/core/Avatar';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import Badge from '@material-ui/core/Badge';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ReactDOM from 'react-dom';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Typography from '@material-ui/core/Typography';
import Axios from '../../Imports/Axios';
import { io } from 'socket.io-client';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import Divider from '@material-ui/core/Divider';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import CloseIcon from '@material-ui/icons/Close';
import parse from 'html-react-parser';
import Default from '../Dashboards/Default';
import { Hidden } from '@material-ui/core';
import * as Download from '../../Imports/Download';
import * as Storage from '../../Imports/Storage';
import Push from 'push.js';
let useStyles = theme => ({
  root: {
    position: 'absolute',
    width: '100%',
    height: '100%'
  },
  backdrop: {
    zIndex: 10000,
    color: '#fff'
  },
  main: {
    position: 'absolute',
    left: 80,
    top: 0,
    right: 320,
    [theme.breakpoints.down("sm")]: {
      top: 0,
      right: 0
    },
    bottom: 0
  },
  sideBar: {
    position: 'fixed',
    zIndex: 101,
    top: 0,
    right: 0,
    [theme.breakpoints.down("sm")]: {
      top: 50,
      right: -320,
      width: 140
    },
    width: 70,
    height: '100%',
    background: '#0068ff',
    '&.dark': {
      background: '#181e2c'
    },
    '& .logo': {
      paddingTop: 20,
      textAlign: 'center'
    },
    '& .icons': {
      textAlign: 'center',
      [theme.breakpoints.down("sm")]: {
        textAlign: 'right'
      },
      height: '90%',
      overflow: 'hidden',
      position: 'relative',
      '& div': {
        position: 'absolute',
        top: 0,
        width: '100%'
      },
      '& button': {
        color: '#fff',
        display: 'block',
        padding: 5,
        paddingTop: 8,
        margin: '0 auto 10px auto',
        width: 45,
        height: 45,
        [theme.breakpoints.down("sm")]: {
          width: 130,
          height: 35,
          textAlign: 'right'
        },
        background: 'rgba(255,255,255,0.3)',
        borderRadius: 3,
        border: 'none',
        cursor: 'pointer',
        '& svg': {
          fontSize: 25,
          [theme.breakpoints.down("sm")]: {
            fontSize: 20
          }
        }
      },
      '& button.active': {
        background: 'rgba(0,0,0,0.3)'
      },
      '& button.active:hover': {
        background: 'rgba(0,0,0,0.3)'
      },
      '& button:hover': {
        background: 'rgba(0,0,0,0.1)'
      },
      '& button:focus': {
        outline: 'none'
      }
    },
    '& .scroll': {
      textAlign: 'center',
      '& button': {
        border: 'none',
        background: 'transparent',
        cursor: 'pointer'
      },
      '& svg': {
        color: 'rgba(255,255,255,0.7)'
      },
      '& #downScrollMenuBtn': {
        visibility: 'hidden'
      },
      '& #upScrollMenuBtn': {
        visibility: 'hidden'
      }
    },
    '& .scroll.up': {
      marginTop: 40
    }
  },
  sideBarShow: {
    right: 0
  },
  sideBarSecond: {
    position: 'fixed',
    zIndex: 100,
    width: 250,
    height: '100%',
    right: 70,
    [theme.breakpoints.down("sm")]: {
      top: 50,
      right: -250,
      overflow: 'auto'
    },
    background: '#fff',
    boxShadow: '0 0 9px 5px #c7c5d8',
    borderLeft: '#fff solid 1px',
    '& .user': {
      textAlign: 'center',
      paddingTop: 20,
      '& .avatar': {
        display: 'inline-block',
        width: 80,
        height: 80,
        border: '#ccd4e8 solid 2px',
        boxShadow: '0px 5px 5px 0px rgba(44, 44, 44, 0.2)',
        '& img': {
          padding: 4,
          borderRadius: '50%'
        }
      },
      '& .name': {
        fontSize: 18,
        color: '#1c273c'
      },
      '& .info': {
        color: '#7987a1'
      }
    },
    '&.dark': {
      background: '#252b3c',
      borderLeft: '#252b3c solid 1px',
      boxShadow: '0 0 9px 5px #03050a',
      '& .user': {
        '& .avatar': {
          border: 'rgba(236, 238, 243, 0.1) solid 2px'
        },
        '& .name': {
          color: '#f1f4f9'
        },
        '& .info': {
          color: '#96a3b7'
        }
      }
    }
  },
  sideBarSecondShow: {
    right: 140
  },
  userIcons: {
    marginTop: 0,
    '& .icon': {
      borderRadius: '2px',
      padding: 7,
      border: '#d4d9e0 solid 1px',
      margin: 5
    },
    '& svg': {
      fontSize: 20,
      color: '#324069'
    },
    '&.dark': {
      '& .icon': {
        border: 'rgba(212, 217, 224, 0.2) solid 1px'
      },
      '& svg': {
        color: '#eaeef9'
      }
    }
  },
  notificationBadge: {
    backgroundColor: '#f50057',
    right: 'unset',
    left: -8
  },
  moduleMenu: {
    position: 'absolute',
    bottom: 25,
    top: 215,
    textAlign: 'right',
    marginTop: 10,
    width: 250,
    paddingLeft: 20,
    paddingRight: 20,
    '&:hover': {
      overflow: 'auto'
    },
    [theme.breakpoints.down("sm")]: {
      top: 180
    }
  },
  subMenu: {
    direction: 'rtl',
    padding: 0,
    border: "#e1e7f1 solid 1px",
    boxShadow: "none",
    borderRadius: 5,
    marginBottom: 10,
    margin: 0,
    '&.MuiPaper-root': {
      backgroundColor: 'transparent'
    },
    '& .MuiAccordionDetails-root': {
      direction: 'rtl',
      textAlign: 'right',
      fontFamily: 'Shabnam',
      fontSize: 14,
      color: '#191919',
      padding: 0
    },
    '& .MuiAccordion-root:before': {
      backgroundColor: "red"
    },
    '& .MuiListItemIcon-root': {
      minWidth: 20
    },
    '& .MuiAccordionSummary-root': {
      height: 40,
      minHeight: 40
    },
    '& .listAdd': {
      color: '#51bb25'
    },
    '& .listList': {
      color: '#0068ff'
    },
    '& svg': {
      fontSize: 16,
      position: 'relative',
      top: 4
    }
  },
  subMenuDark: {
    direction: 'rtl',
    padding: 0,
    border: "rgba(222, 228, 247, 0.1) solid 1px",
    boxShadow: "none",
    borderRadius: 5,
    marginBottom: 10,
    margin: 0,
    '&.MuiPaper-root': {
      backgroundColor: 'transparent'
    },
    '& .MuiAccordionDetails-root': {
      direction: 'rtl',
      textAlign: 'right',
      fontFamily: 'Shabnam',
      fontSize: 14,
      color: 'rgba(255, 255, 255, 0.7)',
      padding: 0
    },
    '& .MuiAccordion-root:before': {
      backgroundColor: "red"
    },
    '& .MuiListItemIcon-root': {
      minWidth: 20
    },
    '& .MuiAccordionSummary-root': {
      height: 40,
      minHeight: 40
    },
    '& .listAdd': {
      color: '#51bb25'
    },
    '& .listList': {
      color: '#0068ff'
    },
    '& svg': {
      fontSize: 16,
      position: 'relative',
      top: 4
    }
  },
  subMenuLists: {
    width: "100%",
    '& .MuiListItem-root': {
      textAlign: 'right',
      height: 40,
      minHeight: 40
    }
  },
  subMenuHeader: {
    fontFamily: 'Shabnam',
    fontSize: 13,
    color: '#7987a1'
  },
  allDashboards: {
    border: '#d4d9e0 solid 1px',
    borderRadius: 2,
    padding: 0,
    '& .MuiListItem-root': {
      padding: 5
    },
    '& .title .MuiListItemText-primary': {
      color: '#7987a1'
    },
    '& .MuiListItemText-primary': {
      color: '#324069',
      fontFamily: 'Vazir',
      textAlign: 'right',
      fontSize: 13
    }
  },
  tabs: {
    direction: 'rtl',
    minHeight: 46,
    position: 'fixed',
    borderBottom: '#9c9c9c solid 1px',
    paddingTop: 2,
    paddingRight: 5,
    zIndex: 1000,
    background: '#e0e0e0',
    left: 85,
    right: 320,
    [theme.breakpoints.down("sm")]: {
      position: 'fixed',
      top: 200,
      bottom: 0,
      right: 0,
      left: 0,
      padding: 10,
      background: '#fff',
      boxShadow: '0 0 10px 0 rgba(0,0,0,0.54)',
      borderTopLeftRadius: 20,
      borderTopRightRadius: 20,
      zIndex: 10000
    },
    '& .MuiTabs-indicator': {
      display: 'none',
      backgroundColor: '#0068ff',
      top: 0,
      zIndex: 100
    }
  },
  tabsDark: {
    direction: 'rtl',
    minHeight: 46,
    position: 'fixed',
    borderBottom: 'rgba(255,255,255, 0.4) solid 1px',
    paddingTop: 2,
    paddingRight: 5,
    zIndex: 1000,
    background: '#0d0f14',
    left: 85,
    right: 320,
    [theme.breakpoints.down("sm")]: {
      position: 'fixed',
      top: 200,
      bottom: 0,
      right: 0,
      left: 0,
      padding: 10,
      background: '#0d0f14',
      boxShadow: '0 0 10px 0 rgba(0,0,0,0.54)',
      borderTopLeftRadius: 20,
      borderTopRightRadius: 20,
      zIndex: 10000
    },
    '& .MuiTabs-indicator': {
      display: 'none',
      backgroundColor: '#0068ff',
      top: 0,
      zIndex: 100
    }
  },
  tab: {
    textAlign: 'right',
    height: 41,
    minHeight: 41,
    width: 200,
    overflow: 'hidden',
    marginTop: 0,
    borderRadius: 4,
    marginLeft: 5,
    [theme.breakpoints.down("sm")]: {
      display: 'block',
      width: '100%',
      float: 'none'
    },
    zIndex: 1,
    "&:hover": {
      background: '#d0d0d0'
    },
    "& .MuiTabScrollButton-root:first-child::before": {
      content: "'L'"
    },
    "& .MuiTabScrollButton-root:last-child::after": {
      content: "'R'"
    },
    '& .MuiTab-wrapper': {
      display: 'block',
      textAlign: 'right',
      fontFamily: 'Vazir',
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      width: 160,
      marginRight: -23,
      [theme.breakpoints.down("sm")]: {
        width: '100%',
        marginRight: 0
      }
    },
    '& .MuiTab-wrapper span': {
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      display: 'block'
    },
    '& .MuiTab-labelIcon': {
      minHeight: 'auto'
    },
    '& .tabIcon': {
      float: 'right',
      fontSize: 20,
      marginLeft: 10,
      color: '#324069'
    },
    '&.dark': {
      '& .tabIcon': {
        color: '#eaeef9'
      },
      "&:hover": {
        background: 'rgba(255,255,255,0.2)'
      }
    }
  },
  notificationDialog: {
    direction: 'ltr',
    [theme.breakpoints.down("sm")]: {
      marginTop: 50
    }
  },
  appBar: {
    position: 'relative',
    '& .MuiToolbar-root': {
      justifyContent: 'space-between'
    }
  },
  notificationItem: {
    textAlign: 'right',
    position: 'relative',
    borderBottom: '#ccc solid 1px',
    '& .MuiTypography-root': {
      paddingRight: 40
    }
  },
  notificationItemUnread: {
    background: '#eee',
    color: '#000'
  },
  notificationItemUnreadDark: {
    background: 'rgba(0,0,0,0.2)',
    color: '#eee'
  },
  notificationIcon: {
    position: 'absolute',
    top: 0,
    bottom: 0,
    right: 0,
    width: 55,
    margin: 'auto 0',
    color: '#0053cc',
    fontSize: 25,
    opacity: 0.5
  },
  unreadFlag: {
    position: 'absolute',
    top: 0,
    bottom: 0,
    right: 4,
    width: 7,
    height: 7,
    margin: 'auto 0',
    background: '#0053cc',
    borderRadius: 50,
    opacity: 0.8
  }
});
let jCounterKey = 1;
class Panel extends React.Component {
  timeouts = [];
  constructor(props) {
    super(props);
    this.state = {
      alertSeverityPanel: '',
      alertMessagePanel: '',
      openSnackbarPanel: false,
      connected: true,
      showConnected: false,
      loaded: false,
      openBackdrop: false,
      menuItemsForShow: 0,
      menuItems: 0,
      organizationData: [],
      currentOrganization: 0,
      menuBarHeight: 0,
      fullscreen: false,
      activeTab: 0,
      activeMenu: 0,
      mainMenu: [],
      openedTabs: [],
      openedTabPanels: [],
      loggedInUser: {
        name: '',
        picture: '/images/user.jpg',
        organizationLevels: []
      },
      userOptions: {
        calendar: "fa-IR",
        darkMode: "off",
        language: "6176c25ab013290aa759d35b",
        theme: "default",
        timeZone: "Asia/Tehran"
      },
      showMenu: false,
      showTabs: false,
      isDevice: false,
      notifications: [],
      unreadNotifications: 0,
      openNotification: false,
      permissionNotification: false,
      allowPlaySound: false,
      dialogTitle: '',
      dialogContent: '',
      dialogShow: false,
      dialogButton: '',
      panelIsloading: false,
      dialogClose: () => {
        this.setState({
          dialogShow: false
        }, () => {
          this.setState({
            dialogShow: false
          });
        });
      },
      closeNotification: () => {
        this.setState({
          openNotification: false
        }, () => {
          this.setState({
            openNotification: false
          });
        });
      }
    };
    this.pageSnackMessageFunction = this.pageSnackMessageFunction.bind(this);
    this.pageBackDropFunction = this.pageBackDropFunction.bind(this);
    this.closeTab = this.closeTab.bind(this);
    this.openTab = this.openTab.bind(this);
    this.callEmit = this.callEmit.bind(this);
    this.checkMeForAccess = this.checkMeForAccess.bind(this);
    this.savedDocument = true;
    this.socket = null;
  }
  async componentDidMount() {
    await this.initMenu();
    const sessionId = await Storage.get('sessionId');
    const accessToken = await Storage.get('accessToken');
    const loggedInUser = await Storage.get('loggedInUser', true);
    const userOptions = await Storage.get('userOptions', true);
    if (userOptions.darkMode === 'on') {
      this.toggleDarkMode();
    }
    this.setState({
      userOptions: userOptions,
      permissionNotification: Push.Permission.has()
    });
    await this.loadUserPic(loggedInUser)
    if (document.body.offsetWidth < 960) {
      this.setState({
        isDevice: true
      });
    }
    this.socket = io.connect(`${process.env.REACT_APP_API_SERVER}/panelSocket`, {
      forceNew: true,
      origins: process.env.REACT_APP_API_SERVER,
      query: `sessionId=${sessionId}`
    });
    this.socket.on('connect', async () => {
      this.setState({
        connected: true,
        showConnected: this.state.loaded ? true : false,
        loaded: true
      });
      const timeoutId = setTimeout(() => {
        this.setState({
          showConnected: false
        });
      }, 5000);
      this.timeouts.push(timeoutId);
      let buttons = document.getElementsByClassName('action-button');
      for (let i = 0; i < buttons.length; i++) {
        buttons[i].disabled = false;
      }
      let buttonsOk = document.getElementsByClassName('action-button-ok');
      for (let i = 0; i < buttonsOk.length; i++) {
        buttonsOk[i].disabled = false;
      }
      this.socket.emit("loginToSaad", accessToken);
      await this.notifications();
    });
    this.socket.on('disconnect', reason => {
      this.setState({
        connected: false,
        showConnected: false
      });
      let buttons = document.getElementsByClassName('action-button');
      for (let i = 0; i < buttons.length; i++) {
        buttons[i].disabled = true;
      }
      let buttonsOk = document.getElementsByClassName('action-button-ok');
      for (let i = 0; i < buttonsOk.length; i++) {
        buttonsOk[i].disabled = true;
      }
    });
    this.socket.on('forceLogout', () => {
      this.Logout();
    });
    this.socket.on('userEdited', async userData => {
      const current = new Date();
      const nextYear = new Date();
      nextYear.setFullYear(current.getFullYear() + 1);
      const pic = await Download.view(userData.picture);
      localStorage.setItem('loggedInUser', {
        userId: loggedInUser.userId,
        name: userData.name,
        picture: userData.picture,
        cover: userData.cover,
        organizationLevels: userData.organizationLevels
      });
      this.setState({
        loggedInUser: {
          name: userData.name,
          picture: userData.picture && pic ? pic : '/images/user.jpg',
          organizationLevels: userData.organizationLevels
        }
      });
    });
    this.socket.on('getNotifications', async data => {
      const openTab = obj => {
        this.openTab(obj);
      };
      Push.create(data.title, {
        icon: '/logo192.png',
        dir: 'rtl',
        onClick: function () {
          window.focus();
          const obj = {
            currentTarget: {
              dataset: {
                "document": data.param,
                "id": data.param ? `${data.controller}_${data.action}_${data.param}` : `${data.controller}_${data.action}`,
                "title": data.tabTitle,
                "icon": data.tabIcon,
                "controller": data.controller,
                "action": data.action,
                "notif": data.uuid,
                "seen": data.seen ? 'read' : 'unread'
              }
            }
          };
          openTab(obj);
          this.close();
        }
      });
      const sound = document.getElementById('notificationSound');
      sound.muted = false;
      sound.play();
      let notifications = this.state.notifications;
      const notification = {
        published: {
          ...data
        }
      };
      notifications.unshift(notification);
      this.setState({
        notifications: notifications,
        unreadNotifications: this.state.unreadNotifications + 1
      });
    });
    this.listMenu();
    window.addEventListener("resize", this.listMenu.bind(this));
    if (document.fullscreen) {
      this.setState({
        fullscreen: true
      });
    } else {
      this.setState({
        fullscreen: false
      });
    }
    document.addEventListener("fullscreenchange", () => {
      const {
        fullscreen
      } = this.state;
      this.setState({
        fullscreen: !fullscreen
      });
    });
    ReactDOM.render(<Default userOptions={this.state.userOptions} pageSnackMessage={this.pageSnackMessageFunction} pageBackDrop={this.pageBackDropFunction} savedDocument={this.savedDocument} closeTab={this.closeTab} openTab={this.openTab} callEmit={this.callEmit} socket={this.socket} />, document.getElementById('tabPanel0'));
    this.setState({
      panelIsloading: true
    })
  }
  componentWillUnmount() {
    this.timeouts.forEach(timeoutId => clearTimeout(timeoutId));
  }
  
  callEmit(emitName, data = null) {
    this.socket.emit(emitName, data);
  }
  async loadUserPic(loggedInUser) {
    const sleep = ms => new Promise(resolve => setTimeout(resolve, ms));
    const timeoutId = await sleep(2000);
    this.timeouts.push(timeoutId);
    const pic = await Download.view(loggedInUser.picture);
    this.setState({
      loggedInUser: {
        name: loggedInUser.name,
        picture: loggedInUser.picture && pic ? pic : '/images/user.jpg',
        organizationLevels: loggedInUser.organizationLevels
      }
    });
    
  }
  async notifications() {
    const sleep = ms => new Promise(resolve => setTimeout(resolve, ms));
    await sleep(2000);
    const requestOptions = {
      url: 'users/notifications'
    };
    try {
      const response = await Axios(requestOptions);
      if (response.data.status === 1000) {
        this.setState({
          unreadNotifications: response.data.data.unreadNotifications,
          notifications: response.data.data.notifications
        });
      }
    } catch (error) {
      console.log(error);
    }
  }
  async initMenu() {
    const requestOptions = {
      url: 'users/menu'
    };

    const loggedInUser = await Storage.get('loggedInUser', true)

    try {
      const response = await Axios(requestOptions);
      if (response.data.status === 1000) {
        this.setState({
          mainMenu: response.data.data.mainMenu,
          organizationData: response.data.data.organizationData,
          currentOrganization: loggedInUser.currentOrganization ? loggedInUser.currentOrganization : response.data.data.currentOrganization,
        });

      }
    } catch (error) {
      console.log(error);
    }
  }
  listMenu() {
    const timeoutId = setTimeout(() => {
      const menu = document.getElementById('menu');
      const downScrollMenuBtn = document.getElementById('downScrollMenuBtn');
      const upScrollMenuBtn = document.getElementById('upScrollMenuBtn');
      menu.style.height = '90%';
      downScrollMenuBtn.style.visibility = 'hidden';
      upScrollMenuBtn.style.visibility = 'hidden';
      const menuItemsForShow = Math.floor(menu.offsetHeight / 55) - 2;
      const menuItems = menu.childElementCount;
      let height = menuItemsForShow * 45 + menuItemsForShow * 10;
      let heightStr = height.toString() + 'px';
      menu.style.height = heightStr;
      if (menuItems > menuItemsForShow) {
        const downScrollMenuBtn = document.getElementById('downScrollMenuBtn');
        downScrollMenuBtn.style.visibility = 'visible';
      }
      this.setState({
        menuItemsForShow: menuItemsForShow,
        menuItems: menuItems,
        menuBarHeight: height
      });
    }, 2000);
    this.timeouts.push(timeoutId);
  }
  toggleFullscreen() {
    const {
      fullscreen
    } = this.state;
    const elem = document.documentElement;
    if (!fullscreen) {
      if (elem.requestFullscreen) {
        elem.requestFullscreen();
      }
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      }
    }
  }
  downScrollMenu() {
    const menu = document.getElementById('menu');
    const downScrollMenuBtn = document.getElementById('downScrollMenuBtn');
    const upScrollMenuBtn = document.getElementById('upScrollMenuBtn');
    const {
      menuBarHeight,
      menuItemsForShow
    } = this.state;
    const maxScrollTop = menu.scrollHeight - (menuItemsForShow * 45 + menuItemsForShow * 10);
    menu.scrollTo({
      top: menu.scrollTop + menuBarHeight,
      left: 0,
      behavior: 'smooth'
    });
    const timeoutId =  setTimeout(function () {
      if (menu.scrollTop > maxScrollTop - 10) {
        downScrollMenuBtn.style.visibility = 'hidden';
      }
    }, 500);
    this.timeouts.push(timeoutId);
    upScrollMenuBtn.style.visibility = 'visible';
  }
  upScrollMenu() {
    const menu = document.getElementById('menu');
    const upScrollMenuBtn = document.getElementById('upScrollMenuBtn');
    const downScrollMenuBtn = document.getElementById('downScrollMenuBtn');
    const {
      menuBarHeight
    } = this.state;
    menu.scrollTo({
      top: menu.scrollTop - menuBarHeight,
      left: 0,
      behavior: 'smooth'
    });
    const timeoutId = setTimeout(function () {
      if (menu.scrollTop < 10) {
        upScrollMenuBtn.style.visibility = 'hidden';
      }
    }, 500);
    this.timeouts.push(timeoutId);
    downScrollMenuBtn.style.visibility = 'visible';
  }
  async Logout() {
    const {
      fullscreen
    } = this.state;
    if (fullscreen) {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      }
    }
    this.setState({
      openBackdrop: true
    });
    await Storage.remove('accessToken');
    await Storage.remove('loggedInUser');
    await Storage.remove('userOptions');
    await Storage.remove('sessionId');
    const requestOptions = {
      url: 'users/logout',
      withCredentials: true
    };
    try {
     await Axios(requestOptions);
    } catch (error) {
      console.log(error);
    }
    this.socket.emit("logoutFromSaad");
    const timeoutId = setTimeout(() => {
      window.location = "/";
    }, 2000);
    this.timeouts.push(timeoutId);
  }
  async toggleDarkMode() {
    const {
      classes
    } = this.props;
    let userOptions = this.state.userOptions;
    userOptions.darkMode = userOptions.darkMode === 'off' ? 'on' : 'off';
    this.setState({
      userOptions: userOptions
    }, async () => {
      await Storage.set('userOptions', userOptions);
      const body = document.getElementById('body');
      const sideBar = document.getElementById('sideBar');
      const sideBarSecond = document.getElementById('sideBarSecond');
      const userIcons = document.getElementById('userIcons');
      body.className = this.state.userOptions.darkMode === 'off' ? '' : 'dark';
      if (this.state.userOptions.darkMode === 'off') {
        sideBar.className = this.state.showMenu ? `${classes.sideBar} ${classes.sideBarShow}` : classes.sideBar;
        sideBarSecond.className = this.state.showMenu ? `${classes.sideBarSecond} ${classes.sideBarSecondShow}` : classes.sideBarSecond;
        userIcons.className = classes.userIcons;
      } else {
        sideBar.className = this.state.showMenu ? `${classes.sideBar} ${classes.sideBarShow} dark` : `${classes.sideBar} dark`;
        sideBarSecond.className = this.state.showMenu ? `${classes.sideBarSecond} ${classes.sideBarSecondShow} dark` : `${classes.sideBarSecond} dark`;
        userIcons.className = `${classes.userIcons} dark`;
      }
      const requestOptions = {
        url: 'users/darkMode',
        params: {
          darkMode: this.state.userOptions.darkMode
        }
      };
      try {
        await Axios(requestOptions);
      } catch (error) {
        console.log(error);
      }
    });
  }
  changeMenu(val, obj) {
    const menu = document.getElementById(obj);
    const menus = document.getElementsByClassName('menu-item');
    const menusArray = Object.values(menus);
    menusArray.forEach((item, i) => {
      item.className = 'menu-item';
    });
    menu.className = 'menu-item active';
    if (val === 0) {
      this.setState({
        activeMenu: val,
        activeTab: val
      });
    } else {
      this.setState({
        activeMenu: val
      });
    }
    document.getElementById('moduleMenu').scrollTop = 0;
  }
  changeTab(val) {
    this.setState({
      showTabs: false,
      activeTab: val
    });

    window.dispatchEvent(new CustomEvent("tabChanged", {
      detail: {
          tabId: val
      }
    }));

    window.dispatchEvent(new CustomEvent("tabChangedWarehouseLoading", {
      detail: {
          tabId: val
      }
    }));

    window.dispatchEvent(new CustomEvent("tabChangedPallets", {
      detail: {
          tabId: val
      }
    }));

    window.dispatchEvent(new CustomEvent("tabChangedPlanning", {
      detail: {
          tabId: val
      }
    }));

    window.dispatchEvent(new CustomEvent("tabChangedWarehouseShipping", {
      detail: {
          tabId: val
      }
    }));
  }
  closeTab(event, dataId = null) {
    const closeTabId = event ? event.currentTarget.dataset.id : dataId;
    let openedTabsx = this.state.openedTabs;
    const indexTab = openedTabsx.indexOf(openedTabsx.find(tab => {
      return tab.id === closeTabId;
    }));
    const indexPreTab = indexTab - 1;
    let preTab;
    if (indexPreTab > -1) {
      preTab = openedTabsx[indexPreTab].id;
    } else {
      preTab = 0;
    }
    const timeoutId = setTimeout(() => {
      this.setState({
        activeTab: preTab
      });
      openedTabsx.splice(indexTab, 1);
      this.setState({
        openedTabs: openedTabsx
      });
    }, 500);
    this.timeouts.push(timeoutId);
    const timeoutId2 = setTimeout(() => {
      const obj = document.getElementById(`tabPanel${closeTabId}`);
      if (obj) {
        obj.remove();
      }
    }, 500);
    this.timeouts.push(timeoutId2);
  }
  pageBackDropFunction(option) {
    this.setState({
      openBackdrop: option
    });
  }
  pageSnackMessageFunction(option) {
    this.setState({
      alertSeverityPanel: option.alertSeverity,
      alertMessagePanel: option.alertMessage,
      openSnackbarPanel: option.openSnackbar
    });
  }
  async openTab(event) {
    if (!this.state.connected) {
      return false;
    }
    this.setState({
      showMenu: false,
      openNotification: false
    });
    const tabOpener = event.currentTarget;
    let openedTabs = this.state.openedTabs;
    const id = tabOpener.dataset.id;
    const tab = document.getElementById("tab" + id);
    if (!tab) {
      openedTabs.push({
        id: id,
        title: tabOpener.dataset.title2 ? tabOpener.dataset.title2 : tabOpener.dataset.title,
        icon: tabOpener.dataset.icon
      });
      let openedTabPanels = this.state.openedTabPanels;
      openedTabPanels.push({
        id: id
      });
      this.setState({
        openedTabs: openedTabs,
        openedTabPanels: openedTabPanels,
        openBackdrop: true
      }, async () => {
        const newTab = document.getElementById("tab" + id);
        newTab.click();
        try {
          import(`../${tabOpener.dataset.controller}/${tabOpener.dataset.action}.jsx?v=14020922`).then(Module => {
            const Ui = Module.default;
            ReactDOM.render(<Ui id={id} {...tabOpener.dataset} onLoad={() => {
              if (!this.checkMeForAccess({
                controller: tabOpener.dataset.controller,
                action: tabOpener.dataset.action
              })) {
                this.closeTab(null, id);
              }
            }} userOptions={this.state.userOptions} tabId={id} checkMeForAccess={this.checkMeForAccess} pageSnackMessage={this.pageSnackMessageFunction} pageBackDrop={this.pageBackDropFunction} savedDocument={this.savedDocument} closeTab={this.closeTab} openTab={this.openTab} callEmit={this.callEmit} socket={this.socket} classes={this.classes} />, document.getElementById('tabPanel' + id), () => {
              //this.setState({
              // openBackdrop: false
              //})
            });
          }).catch(e => {
            console.log(e);
            //console.log(JSON.stringify(e, Object.getOwnPropertyNames(e)))
            const timeoutId =setTimeout(() => {
              const indexPreTab = openedTabs.length - 2;
              let preTab;
              if (indexPreTab > -1) {
                preTab = document.getElementById('tab' + openedTabs[indexPreTab].id);
              } else {
                preTab = document.getElementById('tab0');
              }
              preTab.click();
              openedTabs.pop();
              openedTabPanels.pop();
              this.setState({
                alertSeverityPanel: 'error',
                alertMessagePanel: 'خطا در نمایش صفحه',
                openBackdrop: false,
                openSnackbarPanel: true,
                openedTabs: openedTabs,
                openedTabPanels: openedTabPanels
              });
            }, 2000);
            this.timeouts.push(timeoutId);

          });
        } catch (e) {
          const timeoutId2 = setTimeout(() => {
            const indexPreTab = openedTabs.length - 2;
            let preTab;
            if (indexPreTab > -1) {
              preTab = document.getElementById('tab' + openedTabs[indexPreTab].id);
            } else {
              preTab = document.getElementById('tab0');
            }
            preTab.click();
            openedTabs.pop();
            openedTabPanels.pop();
            this.setState({
              alertSeverityPanel: 'error',
              alertMessagePanel: 'خطا در نمایش صفحه',
              openBackdrop: false,
              openSnackbarPanel: true,
              openedTabs: openedTabs,
              openedTabPanels: openedTabPanels
            });
          }, 2000);
          this.timeouts.push(timeoutId2);

        }
      });
      if (tabOpener.dataset.notif && tabOpener.dataset.seen === 'unread') {
        let notifications = this.state.notifications;
        const notifKey = notifications.findIndex(obj => obj.published.uuid === tabOpener.dataset.notif);
        if (notifKey > -1) {
          notifications[notifKey].published.seen = true;
        }
        this.setState({
          notifications: notifications,
          unreadNotifications: this.state.unreadNotifications - 1
        });
        const requestOptions = {
          url: 'users/readNotification',
          params: {
            id: tabOpener.dataset.notif
          }
        };
        const response = await Axios(requestOptions);
        if (response) {
          const reloadNotifIndex = document.getElementById('reloadNotifIndex');
          if (reloadNotifIndex) {
            reloadNotifIndex.click();
          }
        }
      }
    } else {
      tab.click();
    }
  }
  async switchOrganization(organization) {
    this.setState({
      dialogShow: false,
      openBackdrop: true
    });
    const requestOptions = {
      url: 'users/switchOrganization',
      params: {
        organization: organization
      }
    };
    try {
      const response = await Axios(requestOptions);
      if (response.data.status === 1000) {
        let loggedInUser = await Storage.get('loggedInUser', true);
        await Storage.set('loggedInUser', {
          userId: loggedInUser.userId,
          name: loggedInUser.user,
          picture: loggedInUser.picture,
          cover: loggedInUser.cover,
          organizationLevels: loggedInUser.organizationLevels,
          currentOrganization: organization
        });
        const timeoutId = setTimeout(() => {
          window.location = "/";
        }, 1000);
        this.timeouts.push(timeoutId);

      } else {
        this.setState({
          openBackdrop: false,
          alertSeverity: 'error',
          alertMessage: response.data.message,
          openSnackbar: true
        });
      }
    } catch (error) {
      console.log(error);
      this.setState({
        openBackdrop: false,
        alertSeverity: 'error',
        alertMessage: 'عدم دسترسی به سرور',
        openSnackbar: true
      });
    }
  }
  checkMeForAccess(option) {
    let result = false;
    for (let i = 0; i < this.state.mainMenu.length; i++) {
      for (let j = 0; j < this.state.mainMenu[i].subMenu.length; j++) {
        if (option.controller === this.state.mainMenu[i].subMenu[j].controller && option.action === this.state.mainMenu[i].subMenu[j].action) {
          result = true;
          break;
        }
      }
      if (result) {
        break;
      }
    }
    return result;
  }
  render() {
    const {
      classes
    } = this.props;
    const {
      loggedInUser,
      userOptions,
      fullscreen,
      connected,
      showConnected,
      openSnackbarPanel,
      alertSeverityPanel,
      alertMessagePanel,
      activeTab,
      activeMenu,
      mainMenu,
      organizationData,
      currentOrganization,
      openedTabs,
      openedTabPanels,
      openBackdrop,
      showMenu,
      showTabs,
      isDevice,
      notifications,
      unreadNotifications,
      openNotification,
      closeNotification,
      permissionNotification,
      dialogShow,
      dialogClose,
      dialogTitle,
      dialogContent,
      dialogButton,
      panelIsloading
    } = this.state;
    let menuIconName = '';
    let MenuIconComponent;
    let menuIconClass;
    let mainMenuHer = [];
    let subMenuHer = [];
    let subMenuLists = [];
    let subMenuItems = [];
    let lists = [];
    mainMenu.map((item, i) => {
      menuIconName = item.icon;
      MenuIconComponent = Icon[menuIconName];
      menuIconClass = i === 0 ? 'menu-item active' : 'menu-item';
      mainMenuHer.push(<Tooltip key={`tooltip-${i}`} title={item.title} placement="left" classes={{
        tooltip: "toolTip",
        arrow: "toolTipArrow"
      }} arrow>
          <button id={'menu' + String(i)} className={menuIconClass} onClick={this.changeMenu.bind(this, i, 'menu' + String(i))}>
            <MenuIconComponent />
            <Hidden mdUp>
              <span className="menu-title">{item.title}</span>
            </Hidden>
          </button>
        </Tooltip>);
      let index = -1;
      item.subMenu.map(option => {
        if (option.inMenu && option.type === 'label') {
          lists.push({
            title: option.title,
            labelType: option.labelType,
            options: []
          });
          index++;
        } else if (option.inMenu && option.type === 'action') {
          lists[index].options.push(option);
        }
        return option;
      });
      if (i === 0) {
        subMenuItems.push(<div key="item-notif" className="color-green" hidden={permissionNotification}>
            <ListItem onClick={() => {
            Push.Permission.request(() => {
              this.setState({
                permissionNotification: true
              });
              this.pageSnackMessageFunction({
                alertSeverity: 'success',
                alertMessage: 'فعال‌سازی اعلان‌ها با موفقیت انجام شد',
                openSnackbar: true
              });
            });
          }} button>
              <ListItemText primary="فعال‌سازی اعلان‌ها" />
            </ListItem>
          </div>);
      }
      lists.map((list, j) => {
        list.options.map((option, x) => {
          const id = option.dataId ? `${option.controller}_${option.action}_${option.dataId}` : `${option.controller}_${option.action}`;
          subMenuItems.push(<React.Fragment key={`item-${id}`}>
              <ListItem disabled={!this.state.connected} data-id={id} data-document={option.dataId ? option.dataId : 0} data-title={option.title} data-title2={option.title2} data-icon={option.icon} data-controller={option.controller} data-action={option.action} onClick={this.openTab.bind(this)} button>
                <ListItemText primary={option.title} />
              </ListItem>
            </React.Fragment>);
          return option;
        });
        let listHeader;
        let listHeaderClassName = 'listNormal';
        if (list.labelType === 'add') {
          listHeader = <>
            <Icon.Add /> {list.title}
          </>;
          listHeaderClassName = 'listAdd';
        } else if (list.labelType === 'list') {
          listHeader = <>
            <Icon.List /> {list.title}
          </>;
          listHeaderClassName = 'listList';
        } 
        else if (list.labelType === 'engineering') {
          listHeader = <>
            <Icon.Product /> {list.title}
          </>;
          listHeaderClassName = 'listList';
        }
        else if (list.labelType === 'planning') {
          listHeader = <>
            <Icon.Planning /> {list.title}
          </>;
          listHeaderClassName = 'listList';
        }
        else if (list.labelType === 'warehouse') {
          listHeader = <>
            <Icon.Warehouse /> {list.title}
          </>;
          listHeaderClassName = 'listList';
        }
         else if (list.labelType === 'production') {
          listHeader = <>
            <Icon.Production /> {list.title}
          </>;
          listHeaderClassName = 'listList';
        }
        else if (list.labelType === 'management') {
          listHeader = <>
            <Icon.Management /> {list.title}
          </>;
          listHeaderClassName = 'listList';
        }
        else if (list.labelType === 'other') {
          listHeader = <>
            <Icon.Other /> {list.title}
          </>;
          listHeaderClassName = 'listOther';
        } else {
          listHeader = <>
            {list.title}
          </>;
        }
        if (subMenuItems.length > 0) {
          jCounterKey++;
          subMenuLists.push(<Accordion id="subMenu" defaultExpanded={j === 0} key={`accordion-${jCounterKey}`} className={userOptions.darkMode === 'off' ? classes.subMenu : classes.subMenuDark}>
              <AccordionSummary key={`summary-${jCounterKey}`} className={classes.subMenuHeader}>
                <Typography className={listHeaderClassName}>{listHeader}</Typography>
              </AccordionSummary>
              <AccordionDetails key={`details-${jCounterKey}`}>
                <List className={classes.subMenuLists} component="nav">
                  {subMenuItems}
                </List>
              </AccordionDetails>
            </Accordion>);
        }
        subMenuItems = [];
        return list;
      });


      if(i === 0) {
           
        let organizationList = []
        organizationData.map( (organizationItem, z) => {
           organizationList.push(<ListItem disabled={!this.state.connected} key={z} onClick={ () => {
           
            if(organizationItem.id !== currentOrganization) {
              this.setState({
                dialogTitle: 'تغییر سازمان جاری',
                dialogContent: (
                  <div>
                    با تغییر سازمان جاری تمامی برگه‌های باز بسته خواهند شد.
                    <br/>
                    آیا می‌خواهید ادامه دهید؟
                  </div>
                ),
                dialogButton: (<div>
                  <Button onClick={this.state.dialogClose}  color="primary">
                    خیر
                  </Button>
                  <Button onClick={this.switchOrganization.bind(this, organizationItem.id)}  className="bg-blue">
                    بله
                  </Button>
                </div>),
                dialogShow: true
              })
            }
          }} button>
          
           <ListItemText primary={organizationItem.title} />
           <ListItemSecondaryAction>
             <span className="color-green" hidden={(organizationItem.id !== currentOrganization)}><Icon.Save/></span>
           </ListItemSecondaryAction>
           </ListItem>)
           return organizationItem
        })
        

           subMenuLists.push(<Accordion id="subMenu2" hidden={(organizationData.length === 0)} defaultExpanded={true}  className={userOptions.darkMode === 'off' ? classes.subMenu : classes.subMenuDark} key={-1} >
           <AccordionSummary className={classes.subMenuHeader}>
             <Typography className="listNormal">سازمان‌های در دسترس</Typography> 
           </AccordionSummary>
           <AccordionDetails>
           <List
                dense
               className={classes.subMenuLists}
               component="nav"
             >
             {organizationList}
         </List>
           </AccordionDetails>
       </Accordion>)

    

        subMenuItems = []
      }

      subMenuHer.push(<div key={`subMenuDiv-${i}`} hidden={activeMenu !== i}>
          {subMenuLists}
        </div>);
      subMenuLists = [];
      lists = [];
      return item;
    });
    const getOrganizationLevel = levels => {
      let result = '';
      if (levels.length > 0) {
        result = `${levels[0].organization} / ${levels[0].unit} / ${levels[0].level}`;
      }
      for (let i = 0; i < levels.length; i++) {
        if (levels[i].primary) {
          result = `${levels[i].organization} / ${levels[i].unit} / ${levels[i].level}`;
        }
      }
      return result;
    };
    const getNotificationsItems = notifications => {
      let result = [],
        NotifIcon,
        className,
        itemProps = {};
      for (let i = 0; i < 9; i++) {
        if (!notifications[i]) {
          break;
        }
        NotifIcon = Icon[notifications[i].published.tabIcon];
        className = notifications[i].published.seen ? classes.notificationItem : userOptions.darkMode === 'off' ? `${classes.notificationItem} ${classes.notificationItemUnread}` : `${classes.notificationItem} ${classes.notificationItemUnreadDark}`;
        itemProps = {
          "data-document": notifications[i].published.param,
          "data-id": notifications[i].published.param ? `${notifications[i].published.controller}_${notifications[i].published.action}_${notifications[i].published.param}` : `${notifications[i].published.controller}_${notifications[i].published.action}`,
          "data-title": notifications[i].published.tabTitle,
          "data-icon": notifications[i].published.tabIcon,
          "data-controller": notifications[i].published.controller,
          "data-action": notifications[i].published.action,
          "data-notif": notifications[i].published.uuid,
          "data-seen": notifications[i].published.seen ? 'read' : 'unread'
        };
        result.push(<ListItem dir="rtl" {...itemProps} onClick={this.openTab.bind(this)} className={className} button key={i}>
          <ListItemText primary={<> {!notifications[i].published.seen ? <div className={classes.unreadFlag}> </div> : ''} <NotifIcon className={classes.notificationIcon} /> {notifications[i].published.title}</>} secondary={notifications[i].published.content ? parse(notifications[i].published.content) : ' '} />
      </ListItem>);
      }
      return <>{result}</>;
    };
    return <div className={classes.darkMode}>
      <div dir="rtl" className={classes.root}>
        <div className={panelIsloading ? 'panel-loading hide' : 'panel-loading'}>
          <img src="/logo192.png" alt=" " className="rotating-image" />
          <p>لطفا شکیبا باشید . . .</p>
        </div>
        
        <div className='device-menu'>
        <Hidden mdUp><div id='userIcons'>
        <IconButton component="span" className="icon menu" onClick={() => {
                this.setState({
                  showMenu: !showMenu,
                  openNotification: false
                });
              }}>
            <Icon.Menu />
          </IconButton>

          <IconButton component="span" className="icon left logout-btn" onClick={this.Logout.bind(this)}>
                    <Icon.Logout />
                  </IconButton>

        <IconButton component="span" className="icon left" onClick={this.toggleDarkMode.bind(this)}>
        {userOptions.darkMode === 'off' ? <Icon.Moon /> : <Icon.Sun />}
        </IconButton>

          <IconButton component="span" className="icon left" onClick={() => {
                this.setState({
                  openNotification: !openNotification,
                  showMenu: false
                });
              }}>
                    <Badge overlap="rectangular" variant={unreadNotifications > 0 ? 'dot' : 'standard'} className="notificationBadge" classes={{
                  badge: classes.notificationBadge
                }}>
                      <Icon.Notification />
                    </Badge>
          </IconButton>

        </div>
          

                  </Hidden>
            <div className="logo">
            <svg version="1.0" xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 356.000000 356.000000" preserveAspectRatio="xMidYMid meet">

              <g transform="translate(0.000000,356.000000) scale(0.100000,-0.100000)" fill="#0068ff" stroke="none">
                <path d="M3 3233 c6 -365 14 -426 72 -565 89 -211 239 -399 485 -611 52 -45
100 -87 105 -93 6 -6 30 -26 55 -45 25 -19 99 -79 165 -134 66 -55 176 -145
245 -200 69 -54 156 -124 193 -155 38 -30 78 -62 90 -71 l20 -17 -22 -53
c-126 -298 -256 -479 -444 -618 -143 -105 -285 -137 -406 -91 -102 38 -96 13
-99 398 -2 246 -6 339 -15 344 -15 9 -321 10 -394 2 l-53 -7 0 -658 0 -659
323 0 c445 0 582 23 782 131 361 194 600 551 814 1219 80 247 101 302 115 292
54 -41 241 -194 327 -267 58 -49 164 -139 235 -200 188 -160 280 -251 332
-330 47 -71 81 -152 82 -193 0 -35 -26 -79 -52 -86 -13 -3 -163 -6 -335 -6
l-311 0 -18 -48 c-9 -26 -36 -91 -60 -144 -24 -54 -44 -101 -44 -106 0 -5 -36
-64 -80 -130 -44 -67 -80 -124 -80 -127 0 -3 344 -5 765 -5 l765 0 0 328 c0
346 -5 392 -52 512 -32 83 -96 207 -142 280 -86 133 -330 350 -656 585 -144
104 -496 381 -519 409 -17 20 6 86 99 281 89 188 180 323 289 428 117 113 195
152 301 152 112 -1 191 -43 237 -128 16 -28 18 -69 21 -349 l3 -317 47 -3 c26
-2 120 -2 210 0 l162 3 0 691 0 690 -292 -5 c-319 -6 -385 -14 -555 -68 -177
-57 -323 -147 -458 -283 -248 -250 -366 -489 -570 -1161 -23 -75 -88 -215
-100 -215 -4 0 -202 163 -345 284 -47 39 -110 92 -140 116 -89 73 -159 138
-276 254 -203 204 -291 399 -213 477 18 18 36 19 404 19 319 0 385 2 385 14 0
24 37 128 72 206 39 85 125 221 186 295 23 27 42 53 42 57 0 5 -383 8 -852 8
l-851 0 6 -327z" />
              </g>
            </svg>
            </div>
        </div>
        <nav id='sideBar' className={showMenu ? `${classes.sideBar} ${classes.sideBarShow} ${userOptions.darkMode === 'on' ? 'dark' : ''}` : `${classes.sideBar}  ${userOptions.darkMode === 'on' ? 'dark' : ''}`}>
            <Hidden smDown>
                <div className="logo">
                <svg version="1.0" xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 356.000000 356.000000" preserveAspectRatio="xMidYMid meet">

                <g transform="translate(0.000000,356.000000) scale(0.100000,-0.100000)" fill="#ffffff" stroke="none">
                  <path d="M3 3233 c6 -365 14 -426 72 -565 89 -211 239 -399 485 -611 52 -45
100 -87 105 -93 6 -6 30 -26 55 -45 25 -19 99 -79 165 -134 66 -55 176 -145
245 -200 69 -54 156 -124 193 -155 38 -30 78 -62 90 -71 l20 -17 -22 -53
c-126 -298 -256 -479 -444 -618 -143 -105 -285 -137 -406 -91 -102 38 -96 13
-99 398 -2 246 -6 339 -15 344 -15 9 -321 10 -394 2 l-53 -7 0 -658 0 -659
323 0 c445 0 582 23 782 131 361 194 600 551 814 1219 80 247 101 302 115 292
54 -41 241 -194 327 -267 58 -49 164 -139 235 -200 188 -160 280 -251 332
-330 47 -71 81 -152 82 -193 0 -35 -26 -79 -52 -86 -13 -3 -163 -6 -335 -6
l-311 0 -18 -48 c-9 -26 -36 -91 -60 -144 -24 -54 -44 -101 -44 -106 0 -5 -36
-64 -80 -130 -44 -67 -80 -124 -80 -127 0 -3 344 -5 765 -5 l765 0 0 328 c0
346 -5 392 -52 512 -32 83 -96 207 -142 280 -86 133 -330 350 -656 585 -144
104 -496 381 -519 409 -17 20 6 86 99 281 89 188 180 323 289 428 117 113 195
152 301 152 112 -1 191 -43 237 -128 16 -28 18 -69 21 -349 l3 -317 47 -3 c26
-2 120 -2 210 0 l162 3 0 691 0 690 -292 -5 c-319 -6 -385 -14 -555 -68 -177
-57 -323 -147 -458 -283 -248 -250 -366 -489 -570 -1161 -23 -75 -88 -215
-100 -215 -4 0 -202 163 -345 284 -47 39 -110 92 -140 116 -89 73 -159 138
-276 254 -203 204 -291 399 -213 477 18 18 36 19 404 19 319 0 385 2 385 14 0
24 37 128 72 206 39 85 125 221 186 295 23 27 42 53 42 57 0 5 -383 8 -852 8
l-851 0 6 -327z" />
                </g>
              </svg>
            </div>
            </Hidden>

            <div className="scroll up">
                <button onClick={this.upScrollMenu.bind(this)} id="upScrollMenuBtn">
                  <Icon.Up />
                </button>

            </div>
            <div className="icons" id="menu">
              {mainMenuHer}

            </div>
            <div className="scroll">

                <button onClick={this.downScrollMenu.bind(this)} id="downScrollMenuBtn">
                  <Icon.Down />
                </button>
            </div>
        </nav>

        <nav id='sideBarSecond' className={showMenu ? `${classes.sideBarSecond} ${classes.sideBarSecondShow} ${userOptions.darkMode === 'on' ? 'dark' : ''}` : `${classes.sideBarSecond} ${userOptions.darkMode === 'on' ? 'dark' : ''}`}>
            <div className="user">
                <Avatar className="avatar" src={loggedInUser.picture} alt={loggedInUser.name} />
                <div className="name">{loggedInUser.name}</div>
                <div className="info">{getOrganizationLevel(loggedInUser.organizationLevels)}</div>
                <Hidden smDown><div id='userIcons' className={classes.userIcons}>
                <Tooltip title="اعلان‌ها" placement="left" classes={{
                  tooltip: "toolTip",
                  arrow: "toolTipArrow"
                }} arrow>
                      <IconButton component="span" className="icon" onClick={() => {
                    this.setState({
                      openNotification: !openNotification
                    });
                  }}>
                                <Badge overlap="rectangular" variant={unreadNotifications > 0 ? 'dot' : 'standard'} className="notificationBadge" classes={{
                      badge: classes.notificationBadge
                    }}>
                                  <Icon.Notification />
                                </Badge>
                              </IconButton>
                              
                  </Tooltip>
                

                  
                  <Hidden xsUp>
                    <IconButton component="span" className="icon">
                      <Badge overlap="rectangular" color="secondary" variant="dot">
                          <Icon.Chat />
                      </Badge>
                    </IconButton>
                  </Hidden>

                  <Tooltip title={fullscreen ? 'خروج از تمام صفحه' : 'تمام صفحه'} placement="left" classes={{
                  tooltip: "toolTip",
                  arrow: "toolTipArrow"
                }} arrow>
                  <IconButton component="span" className="icon" onClick={this.toggleFullscreen.bind(this)}>
                  {!fullscreen && <Icon.Fullscreen />}

                  {fullscreen && <Icon.FullscreenExit />}

                  </IconButton>
                  </Tooltip>
                  
                  <Tooltip title={userOptions.darkMode === 'off' ? 'حالت تیره' : 'حالت روشن'} placement="left" classes={{
                  tooltip: "toolTip",
                  arrow: "toolTipArrow"
                }} arrow>
                    <IconButton component="span" className="icon" onClick={this.toggleDarkMode.bind(this)}>
                    {userOptions.darkMode === 'off' ? <Icon.Moon /> : <Icon.Sun />}
                  </IconButton>
                  </Tooltip>
                  

                  <Tooltip title="خروج" placement="left" classes={{
                  tooltip: "toolTip",
                  arrow: "toolTipArrow"
                }} arrow>
                    <IconButton component="span" className="icon  logout-btn" onClick={this.Logout.bind(this)}>
                    <Icon.Logout />
                  </IconButton>
                  </Tooltip>
                  
                </div></Hidden>
                
            </div>

            <div id="moduleMenu" className={classes.moduleMenu}>
              {subMenuHer}
            </div>
        </nav>



        <div id="main" className={classes.main} onClick={() => {
          this.setState({
            showMenu: false
          });
        }}><div hidden={!showTabs} className='tab-mask' onClick={() => {
            this.setState({
              showTabs: false
            });
          }}> </div>
            <div hidden={isDevice ? showTabs ? false : true : false}>
            <Tabs id="tabs" className={userOptions.darkMode === 'off' ? classes.tabs : classes.tabsDark} value={activeTab} variant="scrollable" scrollButtons="auto">
              
                  <Tab id="tab0" value={0} icon={<Icon.Dashboard className="tabIcon" />} label={<Tooltip title="پیشخوان" placement="bottom" classes={{
                tooltip: "toolTip",
                arrow: "toolTipArrow"
              }} arrow>
                      <span>پیشخوان</span>
                    </Tooltip>} className={userOptions.darkMode === 'off' ? classes.tab : `${classes.tab} dark`} onClick={this.changeTab.bind(this, 0)} />

                {openedTabs.map((item, i) => {
                let TabIconComponent = Icon[item.icon];
                return <Tab key={item.id} id={`tab${item.id}`} value={item.id} icon={<TabIconComponent className="tabIcon" />} label={<Tooltip title={item.title} placement="bottom" classes={{
                  tooltip: "toolTip",
                  arrow: "toolTipArrow"
                }} arrow><span> {item.title} <div className="tab-close" data-id={item.id} onClick={this.closeTab.bind(this)}><Icon.Close /></div> </span></Tooltip>} className={userOptions.darkMode === 'off' ? classes.tab : `${classes.tab} dark`} onClick={this.changeTab.bind(this, item.id)} />;
              })}
            

            </Tabs>
            </div>
            
            <div className="nana">
              <Hidden mdUp>
              <Button className="device-button" onClick={() => {
                this.setState({
                  showTabs: true
                });
              }}>
                  {openedTabs.length + 1}
              </Button>
              </Hidden>
            </div>
            <div className="tab-panel" id="tabPanel0" hidden={0 !== activeTab}>
            </div>
            {openedTabPanels.map((item, i) => {
            return <div key={i} className="tab-panel" id={`tabPanel${item.id}`} hidden={item.id !== activeTab}></div>;
          })}



        </div>
        </div>
        <div className='connect-status color-red' hidden={connected}>
          <Icon.Disconnect />
          <strong>ارتباط با سرور برقرار نیست,</strong> در حال تلاش مجدد ...
        </div>
        <div className='connect-status color-green' hidden={!showConnected}>
          <Icon.Connect />
          <strong>ارتباط با سرور برقرار شد</strong>
        </div>
        <Backdrop className={classes.backdrop} id="mask" open={openBackdrop}>
          <CircularProgress color="inherit" />
        </Backdrop>

        <Snackbar autoHideDuration={4000} className="snackbar" open={openSnackbarPanel} onClose={() => this.setState({
        openSnackbarPanel: false
      })} anchorOrigin={{
        vertical: 'top',
        horizontal: 'center'
      }}>
          <Alert id="alert" variant="filled" severity={alertSeverityPanel} action={<Icon.Close aria-label="close" onClick={() => this.setState({
          openSnackbarPanel: false
        })} color="inherit" />}>
            <pre className="pre-alert">{alertMessagePanel}</pre>
          </Alert>
        </Snackbar>

        <Dialog open={dialogShow} onClose={dialogClose}>
              <DialogTitle>{dialogTitle}</DialogTitle>
              <DialogContent>
                <DialogContentText>
                  {dialogContent}
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                
                
                {dialogButton}
              </DialogActions>
              </Dialog>


      <Dialog fullScreen open={openNotification} className={classes.notificationDialog} onClose={closeNotification}>
        <AppBar className={classes.appBar}>
          <Toolbar>
          <IconButton className='close' edge="end" color="inherit" onClick={closeNotification} aria-label="close">
              <CloseIcon />
            </IconButton>

            <Button data-id='notifications_index' data-title='فهرست اعلان‌ها' data-icon="Notification" data-controller="Users" data-action="notificationsIndex" autoFocus color="inherit" onClick={this.openTab.bind(this)}>
                <Badge overlap="rectangular" badgeContent={unreadNotifications} classes={{
                badge: classes.notificationBadge
              }}><pre>مشاهده همه موارد   </pre></Badge>
            </Button>

          </Toolbar>
        </AppBar>
        <List>
          {getNotificationsItems(notifications)}
          <Divider />
        </List>
      </Dialog>

      </div>;
  }
}
export default withStyles(useStyles)(Panel);